// jeden rok v milisekundach
export const ONE_YEAR = 31536000000;

export const WHITE_LIST_LOG_ACTION_IN_FRAME = [
	"iframe",
	"detail",
	"route",
	"circuit",
	"correction",
	"search_result",
	"search_selection",
	"firmy-vizitka-doruceni",
	"firmy-companyUrl",
	"firmy-vizitka-akce",
];

export const MAX_URL_LENGTH = 2000;

export const SATURATION_MAPSETS = ["zakladni", "zimni", "turisticka", "fotografie"];

export const DEFAULT_VALUE_USER_SPEED = {
	121: {
		value: 18,
	},
	122: {
		value: 18,
	},
	123: {
		value: 18,
	},
	124: {
		value: 18,
	},
	125: {
		value: 10,
	},
	131: {
		value: 4,
	},
	132: {
		value: 4,
	},
	133: {
		value: 3,
	},
	134: {
		value: 8,
	},
	141: {
		value: 6,
	},
	142: {
		value: 6,
	},
	143: {
		value: 4,
	},
	144: {
		value: 4,
	},
};

export const APPLE_STORE_LINKS = {
	cs: "https://apps.apple.com/cz/app/id411411020?l=cs&pt=282263&ct=mapy_web-footer-promo&mt=8",
	de: "https://apps.apple.com/de/app/id411411020?l=de&pt=282263&ct=mapy_web-footer-promo&mt=8",
	en: "https://apps.apple.com/cz/app/id411411020?pt=282263&ct=mapy_web-footer-promo&mt=8",
	it: "https://apps.apple.com/it/app/id411411020?l=it&pt=282263&ct=mapy_web-footer-promo&mt=8",
	sk: "https://apps.apple.com/sk/app/id411411020?l=sk&pt=282263&ct=mapy_web-footer-promo&mt=8",
	pl: "https://apps.apple.com/pl/app/id411411020?l=pl&pt=282263&ct=mapy_web-footer-promo&mt=8",
	uk: "https://apps.apple.com/cz/app/id411411020?l=uk&pt=282263&ct=mapy_web-footer-promo&mt=8",
	ru: "https://apps.apple.com/cz/app/id411411020?l=ru&pt=282263&ct=mapy_web-footer-promo&mt=8",
};

export const GOOGLE_PLAY_STORE_LINKS = {
	cs: "https://play.google.com/store/apps/details?id=cz.seznam.mapy&hl=cs&utm_source=mapy_mobilni-web&utm_medium=footer&utm_campaign=mapy-app-promo-internal&utm_content=cs-lang&referrer=footer",
	de: "https://play.google.com/store/apps/details?id=cz.seznam.mapy&hl=de&utm_source=mapy_mobilni-web&utm_medium=footer&utm_campaign=mapy-app-promo-internal&utm_content=de-lang&referrer=footer",
	en: "https://play.google.com/store/apps/details?id=cz.seznam.mapy&hl=en&utm_source=mapy_mobilni-web&utm_medium=footer&utm_campaign=mapy-app-promo-internal&utm_content=en-lang&referrer=footer",
	it: "https://play.google.com/store/apps/details?id=cz.seznam.mapy&hl=it&utm_source=mapy_mobilni-web&utm_medium=footer&utm_campaign=mapy-app-promo-internal&utm_content=it-lang&referrer=footer",
	sk: "https://play.google.com/store/apps/details?id=cz.seznam.mapy&hl=sk&utm_source=mapy_mobilni-web&utm_medium=footer&utm_campaign=mapy-app-promo-internal&utm_content=sk-lang&referrer=footer",
	pl: "https://play.google.com/store/apps/details?id=cz.seznam.mapy&hl=pl&utm_source=mapy_mobilni-web&utm_medium=footer&utm_campaign=mapy-app-promo-internal&utm_content=pl-lang&referrer=footer",
	uk: "https://play.google.com/store/apps/details?id=cz.seznam.mapy&hl=uk&utm_source=mapy_mobilni-web&utm_medium=footer&utm_campaign=mapy-app-promo-internal&utm_content=uk-lang&referrer=footer",
	ru: "https://play.google.com/store/apps/details?id=cz.seznam.mapy&hl=ru&utm_source=mapy_mobilni-web&utm_medium=footer&utm_campaign=mapy-app-promo-internal&utm_content=ru-lang&referrer=footer",
};

export const TWEAKS_ID = {
	cs: {
		tagID: 537,
		shortInfo: 1365,
	},
	en: {
		tagID: 1750,
		shortInfo: 2218,
	},
	sk: {
		tagID: 2183,
		shortInfo: 2226,
	},
	pl: {
		tagID: 2185,
		shortInfo: 2228,
	},
	de: {
		tagID: 2187,
		shortInfo: 2234,
	},
	it: {
		tagID: 2189,
		shortInfo: 2230,
	},
};
